import { render, staticRenderFns } from "./Personnel.vue?vue&type=template&id=497d97be&scoped=true"
import script from "./Personnel.vue?vue&type=script&lang=js"
export * from "./Personnel.vue?vue&type=script&lang=js"
import style0 from "./Personnel.vue?vue&type=style&index=0&id=497d97be&prod&scoped=true&lang=scss"
import style1 from "./Personnel.vue?vue&type=style&index=1&id=497d97be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497d97be",
  null
  
)

export default component.exports